import { AboutTransportSection } from "@/components/sections/section-about-transporte";
import { CidadesSection } from "@/components/sections/section-cities-path";
import { HowWorkSection } from "@/components/sections/section-how-work";

const CidadesPage = () => {
  return (
    <div className="bg-n-bg-1">
      {/* Cidades Section */}
      <CidadesSection number={30} />

      {/* About Transport Section */}
      <AboutTransportSection cityName="todo o Brasil" stateName="conheça!" />

      {/* How It Works Section */}
      <HowWorkSection cityName="todo o Brasil" />
    </div>
  );
};

export default CidadesPage;
